import { PortableText } from "@portabletext/react";
import Image from "next/image";
import { urlFor } from "@/sanity/lib/image";
import styles from "./styles.module.scss";
import Button from "@/components/Button";
import { portableTextComponents } from "../../../lib/portableTextComponents";

export function Hero({ title, titleColor, text, image, buttons }) {
  return (
    <section className={styles.hero}>
      {image && (
        <>
          <div className={styles.image}>
            <Image
              src={urlFor(image).url()}
              alt="background-image"
              fill
              sizes="100vw"
              placeholder="blur"
              blurDataURL="/grey-placeholder.jpg"
              style={{ objectFit: "cover", objectPosition: "center" }}
            />
          </div>
          <div className={styles.overlay} />
        </>
      )}

      <div className={styles.content}>

        {title && <h1
          className={styles.title}
          style={titleColor ? { color: `rgba(${titleColor.rgb.r},${titleColor.rgb.g},${titleColor.rgb.b},${titleColor.rgb.a})` } : {}}
        >{title}</h1>}


        {text && (
          <div
            className={styles.text}
          >
            <PortableText components={portableTextComponents} value={text} />
          </div>
        )}

        {buttons?.length > 0 && (
          <div className={styles.buttonGroup}>
            {buttons.map((button) =>
              button?.isExternal ? (
                <Button
                  type="link"
                  key={button.url}
                  href={button.url}
                  className={(button.color || "primary")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {button.text}
                </Button>
              ) : (
                <Button
                  type="link"
                  key={button.url}
                  href={button.url}
                  className={(button.color || "primary")}
                >
                  {button.text}
                </Button>
              )
            )}
          </div>
        )}
      </div>
    </section>
  );
}
